import { css } from '@emotion/css';

import { AlignItems, Color, FlexDirection, Font, FontWeight, ScreenBreakpoint, Spacing } from '../../../../styles';

export const headerContainer = css`
  ${Spacing.mx16}
  ${Spacing.mt32}
  ${Spacing.mb16}
  ${FlexDirection.column}
  ${AlignItems.flexStart}

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${FlexDirection.row}
    ${AlignItems.center}
  }
`;

export const titleContainer = css`
  ${Spacing.mb16}

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${Spacing.mb0}
  }
`;

export const tableContainer = css`
  width: 100%;
`;

// duplicate
export const amountValue = ({ isNegative }: { isNegative: boolean }) => css`
  ${FontWeight.bold}
  ${Font.lg}
  color: ${isNegative ? Color.Red8 : Color.Green8};
`;
